import { useDates } from "../../../dates/DatesContext";
import moment from "moment";
import useDSPSellerInfo from "./useDSPSellerInfo";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import type { DatasetsQueryFilter } from "../../../zodios/apiDefinitions/api/dsp/common";

export const useDSPProductDatasetsQuery = (options?: {
  dimensions?: string | string[];
  lineItemId?: string | number | null;
  asin?: string | null;
  reportGranularity?: string | null;
  featuredAsin?: string | null;
  enabled?: boolean;
}) => {
  const { start, end, preStart, preEnd } = useDates();
  const { dspAdvertiser } = useDSPSellerInfo();

  const startDate = moment(start).format("YYYY-MM-DD");
  const endDate = moment(end).format("YYYY-MM-DD");
  const preStartDate = moment(preStart).format("YYYY-MM-DD");
  const preEndDate = moment(preEnd).format("YYYY-MM-DD");

  const filters: DatasetsQueryFilter[] = [
    { id: "start_date", value: { op: "gte", value: startDate } },
    { id: "start_date", value: { op: "lte", value: endDate } },
    { id: "date_prev", value: { op: "gte", value: preStartDate } },
    { id: "date_prev", value: { op: "lte", value: preEndDate } },
  ];

  if (dspAdvertiser?.id) {
    filters.push({ id: "dsp_seller_info_id", value: { op: "eq", value: dspAdvertiser.id } });
  }

  if (options?.lineItemId) {
    filters.push({ id: "line_item_id", value: { op: "eq", value: options.lineItemId } });
  }

  if (options?.asin) {
    filters.push({ id: "asin", value: { op: "eq", value: options.asin } });
  }

  if (options?.reportGranularity) {
    filters.push({ id: "report_granularity", value: { op: "eq", value: options.reportGranularity } });
  }

  if (options?.featuredAsin) {
    filters.push({ id: "featured_asin", value: { op: "eq", value: options.featuredAsin } });
  }

  const dimensions = options?.dimensions ?? ["asin", "conversion_type"];

  const body = {
    model: "dspproduct" as const,
    dimensions,
    filters,
  };

  return useQuery({
    queryKey: ["dspProductDatasets", startDate, endDate, preStartDate, preEndDate, dimensions, filters],
    enabled: options?.enabled !== undefined ? options.enabled : !!dspAdvertiser?.id,
    queryFn: async () => {
      return await apiClient.dspProductDatasetsQuery(body);
    },
  });
};
